module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/cta1_dochimom-92081c6a382f457a97a80469e3c89e75.png";